export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly body: unknown
  ) {
    super(`Request failed with status ${status}`);
    this.name = "ApiError";
  }
}
